<form [formGroup]="form" fxLayout="row" [fxLayoutGap]="LYT_GAP">
  <div [fxFlex]="COLS[0]" class="first-col" fxLayout="row" fxLayoutAlign="start center" [fxLayoutGap]="LYT_GAP">
    <redispatch-labeled-textbox [text]="rowDesc.description"
    [required]="rowDesc.required"></redispatch-labeled-textbox>
    <redispatch-erzeugungsanlage-form-prefix class="help-icon" [feld]="feldMapping?.kopplungsTyp" [disabled]="!readonly && disabled" tooltipPosition="right"></redispatch-erzeugungsanlage-form-prefix>

    <mat-form-field class="hidden">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.kopplungsTyp" [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Kopplungstyp</mat-label>
      <input matInput
        [redispatchDisableControl]="readonly || disabled"
        formControlName="kopplungsTyp">
    </mat-form-field>
  </div>

  <mat-form-field [fxFlex]="COLS[1]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.tase2Objekt" [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{placeholder}}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      [placeholder]="placeholder"
      formControlName="tase2Objekt">
    @if (f.tase2Objekt.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.tase2Objekt.hasError('pattern')) {
      <mat-error>Es muss dem IEC 60870-6-802:2014 festgelegten Muster
        entsprechen
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field [fxFlex]="COLS[2]">
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="feldMapping?.elementTyp" [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>{{placeholder}}</mat-label>
    <input matInput
      [redispatchDisableControl]="readonly || disabled"
      [placeholder]="placeholder"
      formControlName="elementTyp">
    @if (f.elementTyp.hasError('required')) {
      <mat-error>Pflichtfeld</mat-error>
    }
    @if (f.elementTyp.hasError('minlength')) {
      <mat-error>Mind. 1 Zeichen</mat-error>
    }
    @if (f.elementTyp.hasError('maxlength')) {
      <mat-error>Max. 16 Zeichen</mat-error>
    }
  </mat-form-field>

  <div [fxFlex]="COLS[3]" fxLayoutAlign="center center">
    @if (!form.valid) {
      <mat-icon class="row-warn"
                aria-hidden="false"
                [attr.aria-label]="warningTooltip"
                [matTooltip]="warningTooltip"
      >
        warning
      </mat-icon>
    }
    @if (form.valid) {
      <mat-icon class="row-ok">check_circle</mat-icon>
    }
  </div>
</form>
